import { environment } from 'src/environments/environment';
import { Environment } from '../../models/environment.type';
import { SetupService } from '@services/setup-service/setup.service';

/**
 * This service allows for mocking the environment
 * values in our tests.
 */
export class EnvironmentService {
  private static overrideEnvironment = SetupService.overrideEnvironment;
  /**
   * Gets the environment variables.
   *
   * @returns The environment variables, injected by the Angular build process
   */
  static get environment(): Environment {
    return {
      ...environment,
      ...this.overrideEnvironment,
      appTimeoutMillis: isNaN(+environment.appTimeoutMillis)
        ? /* istanbul ignore next */ 5000
        : +environment.appTimeoutMillis,
    };
  }
}
